type Tone = "ok" | "warn" | "no";

export function StatusChip({ tone, label }: { tone: Tone; label: string }) {
  return (
    <span className={`chip ${tone}`}>
      <span className="dot" />
      {label}
    </span>
  );
}

export function boolChip(value: boolean, okLabel = "Yes", noLabel = "No") {
  return value ? (
    <StatusChip tone="ok" label={okLabel} />
  ) : (
    <StatusChip tone="warn" label={noLabel} />
  );
}
